/**
 * LoadBoostsUseCase
 *
 * Returns the boost catalog used by the content monetization step.
 */
import { BoostsService } from '@/domain/services/boosts/boostsService';
import type { BoostEntity } from '@/domain/entities/boost/boostEntity';

export class LoadBoostsUseCase {
  private boostsService: BoostsService;

  constructor() {
    this.boostsService = BoostsService.getInstance();
  }

  execute(): BoostEntity[] {
    return this.boostsService.getBoosts();
  }
}

export const loadBoostsUseCase = new LoadBoostsUseCase();
